<template>
  <div class='container-xl container-fluid'>
    <h1>Test Page</h1>

    <button v-on:click="this.do_something">Do Something</button>
    <button v-on:click="testMoney">Test Money</button>
    <button v-on:click="roulette">RouletteAuthoraize</button>
    <button v-on:click="rouletteResult">RouletteResult</button>
    <button 
      v-on:click="openSidePanel" 
      style="background-color: #3b82f6; border: none; padding: 8px 16px; border-radius: 6px; color: white; cursor: pointer; margin-left: 10px;"
    >
      Тест боковой панели
    </button>

    <div class="content p-4 mt-3">
      <GetInputs 
        :fields="this.fields" 
        :onAlias="true"
        :dataValues="this.fields_values"
        @updateParentState="this.setValue"
      />
    </div>


    <div class="content p-4 mt-3">
      <button v-on:click="downloadPDF">Download PDF</button>
      <button v-on:click="ceckNotify">Check Notify</button>
      <button v-on:click="ratesSetup">Rates Setup</button>
    </div>

    <div class="content p-4 mt-3">
      <button v-on:click="GetProtocolsList">GetProtocolsList</button>
      <button v-on:click="getInfo">Get Info</button>
    </div>
    
  </div>
</template>

<script>
import GetInputs from "@/components/service/GetInputs";


export default {
    components: {
      GetInputs
    },
    data() {
      return {
        fields_values: {
          f1: 'im 1',
          f2: 'im 2',
          f3: 'im 3'
        },
        pdf: {
          title: 'PDF Title',
          content: [
            {
              param1: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.SDAAAAAAAAAAAAAAAAAAAAAAAAAadasdasanajan dbnajdbasdbasdbasdbas abdkasbdasdbadajdajdbafbahkdbadbajdadgbkbgdfughsuhdfufhsaufhaaiofhaiofhsadfuadfuadfuadfuadfuadfuadfuadfuadfuadfuadfuadfuadfuadfuadfuadfuadfuadfuadfuadfuadfuadfuadfuadfuadfuadfuadfuadfuadfuadfuadfuadfuadfuadfuadfuadfuadfuadfuadfuadfu',
              param2: 'value2',
              param3: 'value3'
            },
            {
              param4: 'value4',
              param5: 'value5',
              param6: 'value6'
            },
          ],
          end: {
            param7: 'value7',
          }
        },  
        fields: [
          {
            alias: 'f1',
            name: 'Field 1',
            edit_conditions: '1',
            visible_conditions: '1',
            obligatory_conditions: '1',
            type_field: 'STRING',
          },
          {
            alias: 'f2',
            name: 'Field 2', 
            edit_conditions: '!(f1=="")',
            visible_conditions: '1', 
            obligatory_conditions: '0',
            type_field: 'STRING',
          },
          {
            alias: 'f3',
            name: 'Field 3',
            edit_conditions: '1',
            visible_conditions: '!(f1=="")',
            type_field: 'STRING',
          }
        ]
      }
    },
    mounted() {
      // console.log('mounted', this.isPushVisible);
    },
    methods: {
        do_something() {
          this.axios.post('DoSomething', {data: {cmd: 'free_report'}})
        },
        setValue(arg) {
          this.fields_values[arg.id] = arg.value;
        },
        ceckNotify() {
          this.axios.post('GetDestinations')
        },
        testMoney() {
          this.$store.commit('MODAL', {
            action: true,
            content: {
              width: 608,
              title: 'Test'
            },
            type: 'TestMoney',
          });
        },
        roulette() {
          this.axios.post('RouletteAuthoraize', {member: true});
        },
        rouletteResult() {
          this.axios.post('SendRouletteResult', {member: true, data: {gift_amount: 1000}});
        },
        ratesSetup() {
          this.axios.post('GetRatesSetup');
        },
        downloadPDF() {
          // Создаем форму для отправки GET запроса в новом окне
          const form = document.createElement('form');
          form.method = 'GET';
          form.action = '/DownloadPDF';
          form.target = '_blank';
          
          // Добавляем JSON данные как скрытое поле
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'data';
          input.value = JSON.stringify(this.pdf);
          form.appendChild(input);
          
          // Добавляем форму в DOM, отправляем и удаляем
          document.body.appendChild(form);
          form.submit();
          document.body.removeChild(form);
        },
        openSidePanel() {
          this.$store.commit('SIDE_PANEL_SHOW', {
            title: '',
            content: {
              component: 'AMLCheck',
              props: {}
            }
          });
        },
        GetProtocolsList() {
          this.axios.post('GetProtocolsList');
        },
        getInfo() {
          this.axios.post('GetInfo');
        },

    }
}
</script>
<style lang="scss" scoped>
  div {
    margin-top: 10px;
  }
</style>
